<div class="header">
  <h1 class="title">
    {{ title | translate }}
  </h1>
  <ng-content></ng-content>
  <p axContrast class="text" *ngFor="let subtext of subTexts">{{ subtext }}</p>
</div>
<ax-icon class="logo" [name]="logo"></ax-icon>
